// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import {OFFER_STATUS_META} from '../../utils/constants.js';
import {Text} from '../../comp/text';
import * as cns from './status_badge.module.less';

export function Status_badge({status}){
    const meta = OFFER_STATUS_META[status];
    if (!meta)
        return null;
    const clasess = cn(cns.root, cns[`root__${status}`]);
    return <Text.m className={clasess} span ghost>{meta.name}</Text.m>;
}
